import { t } from 'typegate';
import { DateUnits, ShiftMagnitudes, timeRoudingType } from './dateTime';
export const QueryOperators = {
    sum: 'sum',
    subtract: 'subtract',
    multiply: 'multiply',
    subtractDates: 'subtractDates',
    formula: 'formula',
    countEqual: 'countEqual',
    fetch: 'fetch',
    fetchSpecificId: 'fetchSpecificId',
    shiftDateBackwards: 'shiftDateBackwards',
    shiftDateForwards: 'shiftDateForwards',
};
export const queryOperatorParameters = t.object(t.optionalProperty('numeric', t.array(t.union(t.number, t.string))), t.optionalProperty('formula', t.string), t.optionalProperty('formulaParams', t.any), t.optionalProperty('dateUnit', t.enum(DateUnits)), t.optionalProperty('controlValue', t.unknown), t.optionalProperty('fetch', t.object(t.property('firstNonEmptyValueAt', t.array(t.string)))), t.optionalProperty('fetchSpecificId', t.object(t.property('specificValueAt', t.string), t.property('matchValue', t.string))), t.optionalProperty('shiftDateParams', t.object(t.property('dateFormat', t.string), t.property('timeRoundingType', timeRoudingType), t.property('shiftValue', t.number), t.optionalProperty('shiftMagnitude', t.enum(ShiftMagnitudes)))));
var QueryOperatorNames;
(function (QueryOperatorNames) {
    QueryOperatorNames["sum"] = "sum";
    QueryOperatorNames["subtract"] = "subtract";
    QueryOperatorNames["multiply"] = "multiply";
    QueryOperatorNames["subtractDates"] = "subtractDates";
    QueryOperatorNames["formula"] = "formula";
    QueryOperatorNames["countEqual"] = "countEqual";
    QueryOperatorNames["fetch"] = "fetch";
    QueryOperatorNames["fetchSpecificId"] = "fetchSpecificId";
    QueryOperatorNames["shiftDateBackwards"] = "shiftDateBackwards";
    QueryOperatorNames["shiftDateForwards"] = "shiftDateForwards";
})(QueryOperatorNames || (QueryOperatorNames = {}));
